import axiosService from '../../services/axios/axios.service';
import {
    CreateTaskValidation,
    GetTasksValidation,
    ResponseGetTasks,
    Task,
    TaskResponse,
} from '../../models/task.model';

const getTasks = async (
    params: GetTasksValidation
): Promise<NonNullable<ResponseGetTasks>> => {
    const response = await axiosService.get('/task/tasks', { params });
    return response.data;
};

const updateTask = async (
    params: Task
): Promise<NonNullable<TaskResponse[]>> => {
    const response = await axiosService.put(
        `/task/update/${params._id}`,
        params
    );
    return response.data;
};

const createTask = async (
    params: CreateTaskValidation
): Promise<NonNullable<TaskResponse>> => {
    const response = await axiosService.post('/task/create', params);
    return response.data;
};

const deleteTask = async (taskId: string): Promise<NonNullable<Task>> => {
    const response = await axiosService.delete(`/task/${taskId}`);
    return response.data;
};

const getTaskById = async (taskId: string): Promise<NonNullable<Task>> => {
    const response = await axiosService.get(`/task/${taskId}`);
    return response.data;
};

export { getTasks, updateTask, createTask, deleteTask, getTaskById };
